/* eslint-disable react/prop-types */
import clsx from "clsx";
import styles from "./index.module.css";

const TimeSlot = ({ value, customTimeClassName, onChange }) => {
    return (
        <div className={clsx(styles.timeSlot)}>
            <div className={clsx(styles.timeSlotContainer)}>
                {customTimeClassName && customTimeClassName.map((item, index) => (
                    <div
                        key={index}
                        className={clsx(styles.card, { [styles.activeItem]: value === item?.time })}
                        onClick={() => onChange(item?.time)}
                    >
                        {item?.time}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TimeSlot;
